import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResearchTopicDetailsComponent } from './research-topic-details.component';
const routes: Routes = [
  {
    path: '',
    component: ResearchTopicDetailsComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResearchTopicDetailsRoutingoModule { }